import { type CommonTemplateProps } from '#app/components/Modals/V2/GlobalModalSystem/types.js';
import { ModalTemplateWrapper } from '../ModalTemplateWrapper/ModalTemplateWrapper.js';
import { useCallback } from 'react';

type RemoveContactWarningModalProps = CommonTemplateProps & {
  readonly isLoading: boolean;
  readonly numberOfContacts: number;
  readonly onRemoveContacts: ({ onSuccess }: { onSuccess: () => void }) => void;
};

export const RemoveContactWarningModal = ({
  closeModal,
  isLoading,
  isOpen,
  numberOfContacts,
  onRemoveContacts,
}: RemoveContactWarningModalProps) => {
  const title = `Remove ${numberOfContacts} contractor${
    numberOfContacts === 1 ? '' : 's'
  } from network?`;
  const body = `In addition to removing contractor${
    numberOfContacts === 1 ? '' : 's'
  } from your network, they will also be removed from any lists.`;

  const handleRemoveContacts = useCallback(() => {
    onRemoveContacts({
      onSuccess: () => {
        closeModal();
      },
    });
  }, [closeModal, onRemoveContacts]);

  return (
    <ModalTemplateWrapper
      ariaLabel={title}
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleRemoveContacts,
          isDisabled: isLoading,
          isLoading,
          label: 'Remove',
          variant: 'V2Destructive',
        },
        secondaryCTA: {
          handleOnClick: closeModal,
          isDisabled: isLoading,
          label: 'Cancel',
        },
      }}
      desktopModalSize="md"
      headerText={title}
      isDismissible={false}
      isFullscreenOnMobile={false}
      isOpen={isOpen}
      onClose={closeModal}
      subheaderText={body}
    />
  );
};
